import methods from '@/services/methods'

export default {
  login (data) {
    return methods.sendPost('sessions/login', data, {restrictToast: true})
  },
  logout () {
    return methods.sendDelete('sessions/logout')
  },
  forgotPassword (payload) {
    return methods.sendPost('sessions/forgot_password', payload, {restrictToast: true})
  },
  verifyResetLink (payload) {
    return methods.sendPost('sessions/verify_reset_link', payload)
  },
  resetPassword (payload) {
    return methods.sendPost('sessions/reset_password', payload)
  },
  verifyOtp (payload) {
    return methods.sendPost('sessions/verify_otp', payload, {restrictToast: true})
  },
  lostDevice () {
    return methods.sendGet(`sessions/lost_device`)
  },
  verifyOtpPage () {
    return methods.sendGet(`sessions/otp`, null, {restrictToast: true})
  }
}
